export default "__VITE_ASSET__CB7E8YUY__"